import { render } from "./Updates.vue?vue&type=template&id=d61bd90e"
import script from "./Updates.vue?vue&type=script&lang=js"
export * from "./Updates.vue?vue&type=script&lang=js"

import exportComponent from "/var/tmp/gitlab_runner/builds/tK6kkzxJV/0/electronics/garden-alarm-system/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__